// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__ddWwX","img":"Image_img__7eG5R","skeleton":"Image_skeleton__G4hJF"};